// removed by extract-text-webpack-plugin
module.exports = {"link":"_3GOLJj6pYa","normalColor":"_3ewVssWyKY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PagesModal/PagesModal.scss
// module id = 899
// module chunks = 0